import publicApi from "./modules/public";
import protocolApi from "./modules/protocol";
import adminApi from "./modules/admin";

const gd = {
  /*————————————公共接口————————————*/
  ...publicApi,
  /*————————————协议库接口————————————*/
  ...protocolApi,
  /*————————————后台管理接口————————————*/
  admin: {
    ...adminApi,
  },
};
export default gd;
